"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAuditDetailDtoStatusEnum = exports.DocumentAuditDetailDtoDocumentTypeEnum = void 0;
exports.instanceOfDocumentAuditDetailDto = instanceOfDocumentAuditDetailDto;
exports.DocumentAuditDetailDtoFromJSON = DocumentAuditDetailDtoFromJSON;
exports.DocumentAuditDetailDtoFromJSONTyped = DocumentAuditDetailDtoFromJSONTyped;
exports.DocumentAuditDetailDtoToJSON = DocumentAuditDetailDtoToJSON;
exports.DocumentAuditDetailDtoToJSONTyped = DocumentAuditDetailDtoToJSONTyped;
const DocumentAuditClaimedVaccinationDto_1 = require("./DocumentAuditClaimedVaccinationDto");
const DocumentAuditValidationResultDto_1 = require("./DocumentAuditValidationResultDto");
const DocumentAuditProfileDto_1 = require("./DocumentAuditProfileDto");
const DocumentAuditClaimedCertificationDto_1 = require("./DocumentAuditClaimedCertificationDto");
/**
 * @export
 */
exports.DocumentAuditDetailDtoDocumentTypeEnum = {
    AdminChatAttachment: 'ADMIN_CHAT_ATTACHMENT',
    Certification: 'CERTIFICATION',
    DhsClearanceLetter: 'DHS_CLEARANCE_LETTER',
    DhsRegistryCheckResult: 'DHS_REGISTRY_CHECK_RESULT',
    Orientation: 'ORIENTATION',
    Vaccination: 'VACCINATION'
};
/**
 * @export
 */
exports.DocumentAuditDetailDtoStatusEnum = {
    NeedsReview: 'NEEDS_REVIEW',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
};
/**
 * Check if a given object implements the DocumentAuditDetailDto interface.
 */
function instanceOfDocumentAuditDetailDto(value) {
    if (!('storedDocumentId' in value) || value['storedDocumentId'] === undefined)
        return false;
    if (!('documentType' in value) || value['documentType'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('uploadedAt' in value) || value['uploadedAt'] === undefined)
        return false;
    if (!('claimedCodes' in value) || value['claimedCodes'] === undefined)
        return false;
    if (!('ownedBy' in value) || value['ownedBy'] === undefined)
        return false;
    if (!('uploadedBy' in value) || value['uploadedBy'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('isExpired' in value) || value['isExpired'] === undefined)
        return false;
    if (!('isOutdated' in value) || value['isOutdated'] === undefined)
        return false;
    if (!('humanResult' in value) || value['humanResult'] === undefined)
        return false;
    if (!('llmResult' in value) || value['llmResult'] === undefined)
        return false;
    if (!('externalResult' in value) || value['externalResult'] === undefined)
        return false;
    if (!('downloadUrl' in value) || value['downloadUrl'] === undefined)
        return false;
    if (!('fileSize' in value) || value['fileSize'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    if (!('claimedVaccinations' in value) || value['claimedVaccinations'] === undefined)
        return false;
    if (!('claimedCertifications' in value) || value['claimedCertifications'] === undefined)
        return false;
    return true;
}
function DocumentAuditDetailDtoFromJSON(json) {
    return DocumentAuditDetailDtoFromJSONTyped(json, false);
}
function DocumentAuditDetailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'storedDocumentId': json['storedDocumentId'],
        'documentType': json['documentType'],
        'fileName': json['fileName'],
        'uploadedAt': (new Date(json['uploadedAt'])),
        'claimedCodes': json['claimedCodes'],
        'ownedBy': (0, DocumentAuditProfileDto_1.DocumentAuditProfileDtoFromJSON)(json['ownedBy']),
        'uploadedBy': (0, DocumentAuditProfileDto_1.DocumentAuditProfileDtoFromJSON)(json['uploadedBy']),
        'status': json['status'],
        'isExpired': json['isExpired'],
        'isOutdated': json['isOutdated'],
        'humanResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoFromJSON)(json['humanResult']),
        'llmResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoFromJSON)(json['llmResult']),
        'externalResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoFromJSON)(json['externalResult']),
        'downloadUrl': json['downloadUrl'],
        'fileSize': json['fileSize'],
        'mimeType': json['mimeType'],
        'claimedVaccinations': (json['claimedVaccinations'].map(DocumentAuditClaimedVaccinationDto_1.DocumentAuditClaimedVaccinationDtoFromJSON)),
        'claimedCertifications': (json['claimedCertifications'].map(DocumentAuditClaimedCertificationDto_1.DocumentAuditClaimedCertificationDtoFromJSON)),
    };
}
function DocumentAuditDetailDtoToJSON(json) {
    return DocumentAuditDetailDtoToJSONTyped(json, false);
}
function DocumentAuditDetailDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'storedDocumentId': value['storedDocumentId'],
        'documentType': value['documentType'],
        'fileName': value['fileName'],
        'uploadedAt': ((value['uploadedAt']).toISOString()),
        'claimedCodes': value['claimedCodes'],
        'ownedBy': (0, DocumentAuditProfileDto_1.DocumentAuditProfileDtoToJSON)(value['ownedBy']),
        'uploadedBy': (0, DocumentAuditProfileDto_1.DocumentAuditProfileDtoToJSON)(value['uploadedBy']),
        'status': value['status'],
        'isExpired': value['isExpired'],
        'isOutdated': value['isOutdated'],
        'humanResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoToJSON)(value['humanResult']),
        'llmResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoToJSON)(value['llmResult']),
        'externalResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoToJSON)(value['externalResult']),
        'downloadUrl': value['downloadUrl'],
        'fileSize': value['fileSize'],
        'mimeType': value['mimeType'],
        'claimedVaccinations': (value['claimedVaccinations'].map(DocumentAuditClaimedVaccinationDto_1.DocumentAuditClaimedVaccinationDtoToJSON)),
        'claimedCertifications': (value['claimedCertifications'].map(DocumentAuditClaimedCertificationDto_1.DocumentAuditClaimedCertificationDtoToJSON)),
    };
}
//# sourceMappingURL=DocumentAuditDetailDto.js.map